module.exports = __webpack_public_path__ + "img/Screenshot 2566-07-26 at 15.11.20@2x.800043da.png";